/* ICONS */
import Gift from '@/assets/svgs/gift.svg?react';
import Locked from '@/assets/svgs/locked.svg?react';

/* UTILS */
import { useResponsive } from '@/utils/useResponsive.tsx';
import { useNavigate } from 'react-router-dom';

export type ProductCardProps = {
  id: string;
  name: string;
  sku: string;
  image: string;
  gift?: boolean;
  locked?: boolean;
}

export const ProductCard = ({ id, name, sku, image, gift, locked }: ProductCardProps) => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const cardWidth = isMobile
    ? '!w-[90vw] !h-[45vh]'
    : '!w-[400px] !h-[400px]'

  return (
    <div className="flex flex-col gap-y-[18px] items-center relative">
      <button
        onClick={() => navigate(id)}
        className={`flex items-center justify-center rounded-[14px] overflow-hidden cursor-pointer w-full relative ${cardWidth} ${isMobile ? 'rounded-[10%]' : ''}`}>
        <img src={image} alt="product image" className={`${isMobile ? 'max-h-[50vh]' : 'max-h-[350px]'} ${locked ? 'opacity-50' : ''}`} />
        {gift && (
          <div className="absolute top-6 right-6 rounded-full bg-[#DDD] w-[32px] h-[32px] flex items-center justify-center">
            <Gift />
          </div>
        )}

        {locked && (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#F6F6F6] w-14 h-14 flex items-center justify-center">
            <Locked />
          </div>
        )}
      </button>
      <div className="product-card-footer flex flex-col items-center">
        <p className="text-textXLarge text-center">{name}</p>
        <p className="text-bodySmall opacity-50 text-center sku">{sku}</p>
      </div>
    </div>
  );
};
